import * as angular from "angular";
import {IController} from "angular";

export class FieldsConfigurationsViewComponent implements IController {

  private currentNavItem: any;

  constructor(private $state) {
  }

  $onInit() {
    this.currentNavItem = this.$state.current.url;
  };

}

angular
  .module('bringoz.admin.site-preferences')
  .component('fieldsConfigurationsView', {
    bindings: {

    },
    template: require('./fields-configurations-view.html').default,
    controller: FieldsConfigurationsViewComponent
  });
